<template>
  <div class="app-container">
    <wt-form-table :form.sync="form" @on-button-action="onButtonAction" >
      <wt-form-table-list slot="wtFormTableList" :form.sync="form" @on-button-action="onButtonAction">
        <template slot="unitPrice" slot-scope="data">
          <span>{{ $wtUtil.transMoney(data.row.unitPrice) }}</span>
        </template>
      </wt-form-table-list>
    </wt-form-table>
  </div>
</template>

<script>
export default {
  data() {
    return {
      form: { //  表单数据
        isFormLoading: false,
        formCode: 'MODULE_GARBAGEDELIVERYTYPE',
        formComponent: {
          add: { type: 'component', componentName: 'GarbageDeliveryType-edit', value: 'resetGarbageDeliveryTypeDetailData' },
          edit: { type: 'component', componentName: 'GarbageDeliveryType-edit', value: 'queryGarbageDeliveryTypeDetailData', noRequest: true },
          list: { type: 'default', value: '/modules/garbageDeliveryType/garbageDeliveryTypeList', params: { type: 1 }},
          delete: { type: 'default', value: '/modules/garbageDeliveryType/garbageDeliveryTypeDelete' }
        },
        formInputsData: [{ name: '物品名称', key: 'name', value: '', type: 'text' }],
        formButtonsData: [{ name: '新增', key: 'ADD', action: 'ADD', className: 'primary', hidden: false, permission: 'ADD' },
          { name: '删除', key: 'DELETE', action: 'DELETE_LIST', hidden: false, permission: 'DELETE' }],
        formTableData: [
          { name: '垃圾名称', key: 'name', type: 'text', minWidth: 100 },
          { name: '积分价值(个/kg)', key: 'integral', type: 'text', minWidth: 160 },
          { name: '现金价值(元/kg)', key: 'unitPrice', type: 'custom', minWidth: 160 },
          { name: '减少树木砍伐(颗/kg)', key: 'tree', type: 'text', minWidth: 160 },
          { name: '减少碳排放(kg/kg)', key: 'carbon', type: 'text', minWidth: 160 },
          { name: '减少石油消耗(kg/kg)', key: 'oil', type: 'text', minWidth: 160 }],
        formTableButtonsData: [{ name: '编辑', key: 'EDIT', action: 'EDIT', className: 'primary', hidden: false, permission: 'EDIT' },
          { name: '删除', key: 'DELETE', action: 'DELETE', className: 'danger', hidden: false, permission: 'DELETE' }],
        formResult: {},
        pageData: { currentPage: 0, pageSize: 20, sortName: '', sortOrder: '' },
        formTableProp: { selection: true, index: true, buttonMinWidth: 160, buttonWidth: 160 }
      }
    }
  },
  methods: {
    /*  ------------------------- 按钮相关  -------------------------  */
    onButtonAction(data) {
      console.log(data.row)
      if (data && data.item) {
        if (data.item.action === 'VIEW' || data.item.action === 'EDIT') {
          this.$store.dispatch('setGarbageDeliveryTypeDetailData', JSON.parse(JSON.stringify(data.row)))
        }
      }
    }
  }
}
</script>
